import React from 'react';
import AllRoute from '../router'
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WhatsAppButton from '../../components/WhatsAppButton/WhatsAppButton';


const App = () => { 

  return (
    <div className="App" id='scrool'>
          <AllRoute/>
          <ToastContainer/>
          <WhatsAppButton/>
    </div>
  );
}

export default App;